import { useState } from 'react';
import { basBacnetSetupPageKeys, guidedSectionMapping } from '../../const';
import { CongratsTemplate } from '../../CommonTemplates';
import BacnetDetails from './BacnetDetails';
import BacnetConfiguration from './BacnetConfiguration';
import { useSelector, useDispatch } from 'react-redux';
import { updateSectionStatusThunk } from '../../../../../redux/inputSheet/inputSheetSlice';

const BACnetSetupOnboarding = ({ onClose, setShowSnackbar }) => {
	const [pageNumber, setPageNumber] = useState(0);

	const basBacnetSetupPages = {
		[basBacnetSetupPageKeys.BACNET_DETAILS]: (
			<BacnetDetails
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basBacnetSetupPageKeys.BACNET_CONFIGURATION]: (
			<BacnetConfiguration
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basBacnetSetupPageKeys.SUCCESS]: <BACNetSetupSuccess onClose={onClose} />,
	};

	return <>{basBacnetSetupPages[pageNumber]}</>;
};

function BACNetSetupSuccess({ onClose }) {
	const dispatch = useDispatch();
	const propertyId = useSelector((state) => state.selectedBuilding.prop_id);

	const handleClose = () => {
		dispatch(
			updateSectionStatusThunk({
				propertyId,
				data: {
					[guidedSectionMapping['BACnet Setup'].key]: {
						isComplete: true,
						isStarted: true,
						section_id: guidedSectionMapping['BACnet Setup'].section_id,
					},
				},
			})
		);
		onClose();
	};
	return (
		<CongratsTemplate
			title="Thank you!"
			message="Your information has been saved successfully."
			onClick={handleClose}
		/>
	);
}

export default BACnetSetupOnboarding;
